import { Text } from "@medoma/components/Text/Text";
import { Trans } from "@lingui/react/macro";

export const GuideTemplateKsgr = () => {
  return (
    <Trans>
      <Text element="p">Willkommen im Spital zu Hause</Text>

      <Text element="p">
        Das Hospital@Home Team des Kantonsspitals Graubünden bietet Ihnen bei
        akuten Erkrankungen eine professionelle medizinische Behandlung und
        Betreuung bei Ihnen zu Hause.
      </Text>

      <Text element="p">
        Wir besuchen Sie täglich ärztlich und pflegerisch, verabreichen die
        erforderlichen Medikamente inklusive Infusionen und führen bei Bedarf
        diagnostische Untersuchungen wie Blutentnahmen, EKG oder Ultraschall
        direkt bei Ihnen zu Hause durch.
      </Text>

      <Text element="p">
        Während der Visiten nimmt sich unser medizinisches Fachpersonal
        ausreichend Zeit, um den Therapieplan zu besprechen und Ihre Fragen zu
        beantworten.
      </Text>

      <Text element="p">
        Diese App bietet Ihnen Informationen zu Ihrem Behandlungsverlauf, zum
        Zeitpunkt der Visiten, dazu, welche Fachperson Sie besuchen wird, sowie
        zu weiteren wichtigen Themen. Zudem können Sie über die Chatfunktion
        direkt in dieser App oder telefonisch unter 081 255 26 26 von 08:00 bis
        17:30 Uhr mit uns in Kontakt treten.
      </Text>

      <Text element="p">Wir wünschen Ihnen gute Besserung.</Text>

      <Text element="p">Ihr Hospital@Home Team</Text>
    </Trans>
  );
};
